import { render, staticRenderFns } from "./digitalSurveyRecord.vue?vue&type=template&id=02536382&scoped=true&"
import script from "./digitalSurveyRecord.vue?vue&type=script&lang=js&"
export * from "./digitalSurveyRecord.vue?vue&type=script&lang=js&"
import style0 from "./digitalSurveyRecord.vue?vue&type=style&index=0&id=02536382&prod&lang=scss&"
import style1 from "./digitalSurveyRecord.vue?vue&type=style&index=1&id=02536382&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02536382",
  null
  
)

export default component.exports